export const THEMES = {
	LIGHT: "LIGHT",
	DARK: "DARK",
	NATURE: "NATURE",
};

export const CCMAXLENGTHS = {
	QueueName: 60,
	FlowNameMaxCharacters: 60,
	MediaFileName: 100,
	MediaFileText: 1000,
	KnowledgeDocumentName: 32,
	KnowledgeDocumentDescription: 512,
	McpServerName: 128,
	McpServerUrl: 4000,
};

export const SNACKBAR = {
	SnackBarAutoHideDuration: 6000,
};

export const HTTPSTATUSCODES = {
	StatusCodeSuccess: 200,
	StatusCodeNotModified: 304,
	StatusCodeForbidden: 403,
	StatusCodeNotFound: 404,
	StatusCodeConflict: 409,
	StatusCodeUnprocessableEntity: 422,
	StatusCodeBadRequest: 400,
	StatusCodeNoContent: 204,
};

export const ROWSPERPAGE = {
	DefaultValue: 10,
};

export enum EventType {
	ClickAway = "clickaway",
}

export const GeneratedMediaFileLanguage = {
	Default: "en-US",
};

export const Controllers = {
	User: "user",
	Queue: "queue",
	Flow: "flow",
	QueueUser: "queue-user",
	QueueAnnouncement: "queue-announcement",
	QueueEvent: "queue-event",
	ApplicationInstance: "application-instance",
	Schedule: "schedule",
	Event: "event",
	Announcement: "announcement",
	AnnouncementMedia: "announcement-media",
	WebchatMedia: "media/webchat/entrypoint",
	Elsa: "elsa",
	MessagingElsa: "messaging/elsa",
	RefreshToken: "refresh-token",
	GeneralSettings: "general-settings",
	Reason: "reason",
	Tenant: "tenant",
	TenantManager: "tenantmanager",
	WrapUpCollection: "wrapup",
	Key: "keys",
	GenericEntryPoint: "generics/entry-points",
	MessagingQueue: "messaging/queue",
	MessagingFlow: "messaging/flow",
	MessagingQueueUser: "messaging/queue/user",
	MessagingSchedule: "messaging/schedule",
	Contact: "contact",
	Skill: "skill",
	Tag: "tag",
	EmailEntryPoint: "messaging/email-entry-points",
	WhatsAppEntryPoint: "messaging/whatsapp-entry-points",
	WebchatEntryPoint: "messaging/webchat-entry-points",
	Deployments: "deployments",
	Templates: "templates",
	MessagingQueueTemplate: "messaging/queue/template",
	MessagingEntryPoint: "messaging/entry-points",
	QueueTemplate: "voice/queue/template",
	PowerBi: "power-bi",
	TenantSettings: "tenant-settings",
	AIFeaturesConfiguration: "ai-features-configuration",
	AiAgent: "ai-agents",
	KnowledgeDocument: "knowledge-documents",
	McpServer: "mcp-servers",
	DataRetentions: "data-retention",
	MessagingQueueAnnouncement: "messaging/queue-announcement",
	License: "license",
	Reporting: "reporting",
	QueueAiEscalation: "queue/ai-escalation",
	MessagingQueueAiEscalation: "messaging/queue/ai-escalation",
	AicLocking: "aic-locking",
};

export const GeneralRoutes = {
	Create: "create",
	Update: "update",
	Delete: "delete",
	List: "list",
	Notifications: "notifications",
	RetryKnowledgeSync: "retry-knowledge-sync",
	KnowledgeSyncStatus: "knowledge-sync-status",
	SyncAllUnsyncedKnowledge: "sync-all-unsynced-knowledge",
};

export const TemplateApiRoutes = {
	Messaging: "messaging",
	MessagingAi: "messaging/ai",
	Voice: "voice",
	AIAgentSystemPrompts: "ai-agent-system-prompts",
	AiSummary: "ai-summary",
};

export const AuthApiRoutes = {
	Timezone: "timezone",
	VerifyUser: "verify-user",
	Tenants: "tenants",
	RefreshToken: "web-admin",
	RevokeRefreshToken: "revoke/web-admin",
	SignOut: "sign-out-admin",
	Deployments: "admin-deployments",
};

export const UserApiRoutes = {
	Users: "users",
	ActiveUsers: "active-users",
	AllUsers: "all-users",
};

export const QueueApiRoutes = {
	Queues: "queues",
	TranscriptionLanguages: "transcription-languages",
};

export const GenericQueueApiRoutes = {
	Queues: "queues",
};

export const QueueUserApiRoutes = {
	Membership: "membership",
	VerifyLicenses: "verify-license",
	EnableAcsTeamsExtension: "enable-acs-teams-extension",
};

export const QueueAnnouncementApiRoutes = {
	Announcements: "announcements",
	GetCallbackQueueAnnouncement: "callback-announcement",
};

export const QueueEventApiRoutes = {
	Events: "events",
	CreateEvents: "create-events",
};

export const FlowApiRoutes = {
	Flows: "flows",
};

export const BotApplicationInstanceApiRoutes = {
	ApplicationInstances: "app-instances",
	AllApplicationInstances: "all-app-instances",
	Import: "import",
};

export const TenantApiRoutes = {
	GetAllTenants: "tenants",
};

export const ScheduleApiRoutes = {
	Schedules: "schedules",
	GeAllSchedules: "schedules/all",
};

export const EventApiRoutes = {
	Events: "events",
	AllEvents: "all-events",
};

export const AnnouncementApiRoutes = {
	Announcements: "announcements",
	GetMaxNumberOfAnnouncements: "max-number-of-announcements",
	GetAll: "get-all",
	CreateDynamic: "create-dynamic",
	DynamicAnnouncements: "dynamic-announcements",
	GetDynamic: "get-dynamic",
	DeleteDynamic: "delete-dynamic",
	GetCollectionType: "get-collection-type",
};

export const AnnouncementMediaApiRoutes = {
	GetMaxMediaFileSize: "max-media-file-size",
	UploadToStorage: "upload-to-storage",
	DeleteFromStorage: "delete-from-storage",
	GenerateAudioFile: "generate-audio-file",
	LanguagesAndVoices: "languages-and-voices",
};

export const WebchatMediaApiRoutes = {
	UploadLogoToStorage: "upload-logo",
	DeleteLogoFromStorage: "delete-logo",
};

export const KnowledgeDocumentApiRoutes = {
	Upload: (id: string) => `${id}/upload`,
	GetFile: (id: string) => `${id}/file`,
	DeleteFile: (id: string) => `${id}/delete-file`,
};

export const ContactApiRoutes = {
	ValidateImportFile: "validate-import-file",
	Import: "import",
	DeleteUpload: "delete-upload",
	ImportHistory: "import-history",
};

export const DateTimeFormat = {
	DefaultFormat: "YYYY-MM-DD HH:mm",
	TimeFormat: "HH:mm",
};

export const MediaFileExtension = {
	Wav: "wav",
	Xls: "xls",
	XlsX: "xlsx",
};

export const LogoFileExtensions = {
	Svg: "svg",
	Png: "png",
	Jpg: "jpg",
	Jpeg: "jpeg",
};

export const blobStorage = {
	AnnouncementsTemporaryFolderName: "temp",
};

export const ElsaApiRoutes = {
	FlowPublished: "flow-published",
	HasCycles: "has-cycles",
	CleanUpVersions: "clean-up-versions",
	GetSubflowParents: "get-subflow-parents",
	EnabledOnEscape: "enabled-on-escape",
	MissingOnRedirect: "missing-on-redirect",
	HasPreferredAgentRoutingEnabled: "has-preferred-agent-routing-enabled",
	ElsaText: "elsa-text",
};

export const GeneralSettingsRoutes = {
	Webhooks: "webhooks",
	UpdateWebhooks: "update-webhooks",
	Reasons: "reasons",
	UpdateReasons: "reasons",
	Resync: "resync",
	ResyncAll: "resyncall",
	Keys: "keys",
	SkillsEnabled: "skills-enabled",
	RefreshContract: "refresh-contract",
	RefreshAllContracts: "refresh-all-contracts",
	AllowSupervisorsToManageAllQueueEvents:
		"allow-supervisors-to-manage-all-queue-events",
};

export const TenantSettingsRoutes = {
	Resync: "resync",
	CheckOpenAISettings: "check-open-ai-settings",
	CheckMicrosoftFoundrySettings: "check-microsoft-foundry-settings",
	CheckGroupIsValid: "check-group-is-valid",
	CheckPresenceAccess: "check-presence-access",
	Timezones: "timezones",
	DefaultFont: "default-font",
	CheckLicenseStatusEnabled: "license-status-check/enabled",
	CheckCrmConnection: "check-crm-connection",
	CrmFields: "crm-fields",
	CrmObjects: "crm-sobjects",
	SalesforcePlatformEvents: "salesforce-platform-events",
	CrmReferenceFields: "crm-reference-fields",
	LookupConfigurationSummaries: "lookup-configuration-summaries",
	Cc4AllDefaults: "cc4all-defaults",
	Cc4AllSnapshot: "cc4all-snapshot",
	Permissions: "permissions",
};

export const DefaultSettings = {
	Language: "en",
};

export const WrapUpCollectionApiRoutes = {
	WrapUpCollection: "wrapups",
	MaxLevelValue: "maxlevelvalue",
	GetAllForQueue: "get-all-for-queue",
};

export const GenericEntryPointApiRoutes = {
	GetAppInstances: "app-instances",
	AllEntryPoints: "all-entry-points",
};

export const AIFeaturesConfigurationApiRoutes = {
	Assistants: "assistants",
	Agents: "agents",
	Models: "models",
};

export const AiAgentApiRoutes = {
	AiAgents: "/ai-agents",
};

export const Roles = {
	WebAdmin: "WebAdmin",
	Supervisor: "Supervisor",
	AgentPlus: "AgentPlus",
	CC4AllAdmin: "CC4AllAdmin",
};

export const Claims = {
	Role: "http://schemas.microsoft.com/ws/2008/06/identity/claims/role",
};

export const QueueDefaults = {
	ZeroTimer: "00:00:00",
	VoiceTimeout: "00:03:00",
	MessagingTimeout: "23:59:59",
	Priority: 50,
	VoiceItemUtilization: 75,
	MessagingItemUtilization: 25,
	RemoveFromUnavailableAfter: "00:03:00",
	NeverRemoveFromUnavailable: true,
	RoutingTimePeriod: "23:59:59",
	BullseyeRoutingCycle: "00:00:10",
	BullseyeRoutingCycleMinValue: 1,
	BullseyeRoutingCycleMaxValue: 300,
};

export const QueueFieldLimits = {
	PriorityMinValue: 1,
	PriorityMaxValue: 100,
	ItemUtilizationMinValue: 1,
	ItemUtilizationMaxValue: 100,
	MaxConcurrentInteractionsPerAgentMinValue: 1,
	MaxConcurrentInteractionsPerAgentMaxValue: 100,
};

export const UsersTableHeaderKeys = {
	MemberAllUsers: "member-all-users-header",
	AgentName: "agent-name-header",
	AgentJoined: "agent-joined-header",
	AgentJoinLeave: "agent-joinLeave-header",
	AgentSupervisor: "agent-supervisor-header",
	AgentOperator: "agent-operator-header",
	AgentDesire: "agent-desire-header",
	AgentSkills: "agent-skills-header",
	AgentEdit: "agent-edit-header",
	AgentOutbound: "agent-outbound",
};

export const QueueTranslationKeys = {
	InvalidValue: "Queue.InvalidValue",
	Required: "Queue.Required",
	MaxSimultaneousOfferingAgents:
		"Queue.QueueOptionsTab.MaxSimultaneousOfferingAgents",
};

export const SharedTranslationKeys = {
	NumbersAllowed: "Shared.NumbersAllowed",
};

export const SkillsApiRoutes = {
	Skills: "skills",
	AllSkills: "all-skills",
};

export const SkillsFieldLimits = {
	SkillLevelMinValue: 0,
	SkillLevelMaxValue: 100,
};

export const SkillsTranslationKeys = {
	Required: "Skills.Required",
};

export const TagsApiRoutes = {
	Tags: "tags",
};

export const TagsFieldLimits = {
	NameMaxLength: 32,
	DescriptionMaxLength: 200,
};

export const SkillsDefaults = {
	SkillLevel: 50,
};

export const DashboardTranslationKeys = {
	Queues: "DashBoardSidebar.Queues",
};

export const CommonApiRoutes = {
	AssignedToData: "assigned-to-data",
};

export const MessagingEntryPointApiRoutes = {
	GetEntryPoints: "entry-points",
	AllEntryPoints: "all-entry-points",
};

export const MessagingEntryPointTranslationKeys = {
	Required: "TextEntryPoint.Required",
};

export const ToneStepUserInputOptions = {
	DTMFTone: "1",
	VoiceRecognition: "2",
	DTMFToneAndVoiceRecognition: "3",
};

export const AnnouncementStepTypeOptions = {
	Default: "0",
	Dynamic: "1",
};

export const TemplateRoutes = {
	GetVariables: "variables",
	TestPrompt: "test-prompt",
};

export const EmailEntryPoint = {
	DefaultFolder: "Inbox",
};

export const EmailSendingOptions = {
	AutoReply: "1",
	ToCustomAddress: "2",
};

export const PowerBiRoutes = {
	Insights: "insights",
	WorkspaceUsers: "workspace-users",
};

export const DataRetentions = {
	Settings: "settings",
};

export const LicenseApiRoutes = {
	Child: "child",
	UpdateChild: "update-child",
};

export const EmailAttachmentLimits = {
	MaxTotalAttachmentSizeMBMin: 10,
	MaxTotalAttachmentSizeMBMax: 25,
	MaxAttachmentSizeMBMin: 3,
	MaxAttachmentSizeMBMax: 25,
};

// How many agents a queue may ring at once with the MS Teams toaster offering method.
// DefaultAgents mirrors QueueDefaultValues.MaxSimultaneousOfferingAgents on the backend.
export const SimultaneousOfferingLimits = {
	MinAgents: 2,
	MaxAgents: 10,
	DefaultAgents: 5,
};

export const InteractionOferringInterval = {
	CallMinOfferingTimeMin: 10,
	CallMinOfferingTimeMax: 30,
	CallMaxOfferingTimeMin: 30,
	CallMaxOfferingTimeMax: 60,
	MessagingMinOfferingTimeMin: 10,
	MessagingMinOfferingTimeMax: 300,
	MessagingMaxOfferingTimeMin: 300,
	MessagingMaxOfferingTimeMax: 600,
};

export const AIFeaturesConfigurationDefaults = {
	SystemMessage: `You are tasked with summarizing a text conversation. Use the following guidelines:

Use HTML tags as specified:

<b> for bold section headers (Participants, Topic names).
<p> for paragraph text (participant names and summaries).
<br /> for line breaks between sections.
Format the output as follows:

<b>Participants:</b>
<p>Participant 1 name</p>
<p>Participant 2 name</p>
<br />
Topics: For each topic, follow this structure:
<b>Topic 1 name:</b>
<p>Topic 1 summary</p>
<br />
<b>Topic 2 name:</b>
<p>Topic 2 summary</p>
Be concise: Only summarize the provided content, without inventing new participants, topics, or scenarios.

Respect the conversation's original language, which might not be English.`,
	UserPrompt: `Here is the text conversation. Please summarize it: {conversationContent}`,
};
